import ProductCategoryPage from "@/components/ProductCategoryPage";
import { productPages } from "@/data/productPages";
export default function Nautica() { return <ProductCategoryPage data={productPages.nautica} />; }
